<script lang="ts">
    const slots = $$slots;
</script>

<div class="gw-card">
    {#if slots.actions}
        <div class="gw-card__actions-list">
            <slot name="actions" />
        </div>
    {/if}
    <slot />
</div>

<style>
    .gw-card {
        box-sizing: border-box;
        height: 100%;
        padding: 16px;
        border-radius: var(--gw-border-radius-base);
        background: var(--gw-white-bg);
        box-shadow: var(--gw-pf-default-shadow);
    }

    .gw-card__actions-list {
        position: absolute;
        top: 16px;
        right: 16px;
    }
</style>
